const getCurrentUserName = state => state?.session?.currentUser?.name

const getServiceIntroduction = state =>
  state?.session?.currentUser?.meta?.b2b?.service_introduction !== false

export { getCurrentUserName, getServiceIntroduction }
